import { __ } from '@wordpress/i18n';
import { trash } from '@wordpress/icons';
import { useState } from '@wordpress/element';
import { registerPlugin } from '@wordpress/plugins';
import { Modal, Tooltip, Button, Fill } from '@wordpress/components';

import { Shortcut } from './components/Shortcut';
import { trashPost } from './utils';

import './styles/app.scss';

/**
 * Trash Post In Block Editor.
 *
 * This function returns a JSX component that comprises
 * the Plugin Sidebar and Trash icon.
 *
 * @since 1.0.0
 *
 * @return {JSX.Element} TrashPostInBlockEditor
 */
const TrashPostInBlockEditor = (): JSX.Element => {
	const [ isModalVisible, setIsModalVisible ] = useState( false );
	const { wpVersion } = tpbe;

	// Slot fill name changed in WP 6.6.
	const fillName =
		parseFloat( wpVersion ) >= 6.6
			? 'PinnedItems/core'
			: 'PinnedItems/core/edit-post';

	return (
		<Fill name={ fillName }>
			<Tooltip text={ __( 'Trash Post', 'trash-post-in-block-editor' ) }>
				<Button
					icon={ trash }
					onClick={ () => setIsModalVisible( true ) }
					data-testid="tpbe-trash-btn"
				></Button>
			</Tooltip>
			<Shortcut onKeyDown={ () => setIsModalVisible( true ) } />
			{ isModalVisible && (
				<Modal
					title={ __( 'Trash Post', 'trash-post-in-block-editor' ) }
					focusOnMount="firstContentElement"
					onRequestClose={ () => setIsModalVisible( false ) }
					className="trash-post-modal"
				>
					<p style={ { textAlign: 'center' } }>
						{ __(
							'Are you sure you want to delete this Post?',
							'trash-post-in-block-editor'
						) }
					</p>
					<div id="trash-post-modal__button-group">
						<Button variant="primary" onClick={ trashPost }>
							{ __( 'Yes', 'trash-post-in-block-editor' ) }
						</Button>
						<Button
							variant="secondary"
							onClick={ () => setIsModalVisible( false ) }
						>
							{ __( 'No', 'trash-post-in-block-editor' ) }
						</Button>
					</div>
				</Modal>
			) }
		</Fill>
	);
};

registerPlugin( 'trash-post-in-block-editor', {
	icon: null,
	render: TrashPostInBlockEditor,
} );

export default TrashPostInBlockEditor;
